import { UiFilterOptionType, UiSelectItemInterface } from "@webapp/ui/select/select.models";

export const uiSelectDefaultFilterOption: UiFilterOptionType = (searchValue: string, item: UiSelectItemInterface): boolean => {
  if (item && item.nzLabel) {
    return item.nzLabel.toString().toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
  } else {
    return false;
  }
};
